import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download, Loader2, SlidersVertical } from "lucide-react";
import SongCover from "@/components/creator/SongCover";
import { fmtLufs, listMixes } from "@/lib/mixDeskApi";
import { fmtAgo } from "@/lib/studioApi";

/** My Music Library → Mixes: every song with numbered Mix Desk renders, latest first. */
export default function MixesTab({ onCount, legacy }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    listMixes().then((r) => { setRows(r); onCount?.(r.length); }).catch(() => { setRows([]); onCount?.(0); });
  }, [onCount]);
  if (rows === null) return <div className="flex items-center gap-2 text-white/60"><Loader2 className="h-4 w-4 animate-spin" /> Loading your mixes…</div>;
  return (
    <div className="grid gap-2" data-testid="library-mixes">
      {rows.map(({ song, count, latest }) => (
        <div key={song.id} data-testid={`library-mix-${song.id}`} className="flex flex-col gap-3 rounded-2xl border border-white/[0.08] bg-[#0a0d1c]/80 p-3 md:flex-row md:items-center md:gap-4">
          <div className="flex min-w-0 flex-1 items-center gap-4">
            <SongCover song={song} size="sm" />
            <div className="min-w-0 flex-1">
              <p className="truncate font-display text-sm font-semibold">{song.title}</p>
              <p className="mt-0.5 flex flex-wrap gap-x-2 text-[11px] text-white/45">
                <span data-testid={`library-mix-count-${song.id}`} className="text-amber-200/80">{count} mix{count === 1 ? "" : "es"}</span>
                <span>Latest: Mix {latest.number} · {latest.label}</span><span>{fmtLufs(latest.lufs)}</span><span>{fmtAgo(latest.finished_at)}</span>
              </p>
            </div>
          </div>
          <div className="flex shrink-0 flex-wrap items-center gap-1.5">
            <a href={`${latest.wav_url}?download=1`} download data-testid={`library-mix-wav-${song.id}`} className="inline-flex items-center gap-1 rounded-full border border-white/12 px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider text-white/75 hover:text-white"><Download className="h-3 w-3" /> WAV</a>
            <a href={`${latest.mp3_url}?download=1`} download data-testid={`library-mix-mp3-${song.id}`} className="inline-flex items-center gap-1 rounded-full border border-white/12 px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider text-white/75 hover:text-white"><Download className="h-3 w-3" /> MP3</a>
            <Link to={`/create/song/${song.id}/mix`} data-testid={`library-mix-open-${song.id}`} className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-300 to-orange-500 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-wider text-[#05070f]">
              <SlidersVertical className="h-3 w-3" /> Mix Desk <ArrowRight className="h-3 w-3" />
            </Link>
          </div>
        </div>
      ))}
      {!rows.length ? <p data-testid="library-mixes-empty" className="rounded-3xl border border-dashed border-white/10 p-8 text-center text-white/55">No Mix Desk mixes yet. Open a song → Mix Desk, balance the parts and press Render.</p> : null}
      {legacy}
    </div>
  );
}
